import React from "react";
import { Modal, Button } from "semantic-ui-react";

const NavigationBlockModal = ({ open, handleCloseModal, handleSubmit }) => {
    const size = "tiny";
    return (
        <div>
            <Modal size={size} open={open} onClose={handleCloseModal}>
                <Modal.Header>Delete Your Account</Modal.Header>
                <Modal.Content>
                    <p>
                        You didn't submit your test. If you leave now, it'll
                        automatically submit your test and generate result
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={handleCloseModal}>
                        No
                    </Button>
                    <Button
                        positive
                        icon="checkmark"
                        labelPosition="right"
                        content="Yes"
                        onClick={handleSubmit}
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default NavigationBlockModal;
